const { getObjectValue } = require('@root/helpers');

let state = {
	dark: null,
	drawerSizes: {
		primary: {
			mini: 80,
			full: 194,
		},
		profile: {
			full: 290,
		},
	},
	mini: null,
	fluid: null,
	notifications: [],
	primaryDrawer: null,
	privacy: false,
	profileDrawer: false,
	users: [],
	searchQuery: '',
	app_name: '',
	theme: getObjectValue('Spark.theme', window, {
		primary: '#2f4255',
		secondary: '#45627f',
		tertiary: '#959EA9',
		lightbg: '#F5F9FE',
		accent: '#7c7c7c',
		error: '#ff0000',
		success: '#00bb9a',
	}),
	requests: {},
};

module.exports = Object.assign(state, window.Spark.state);
